import mockData from '../../../features/widget-series-list/fixtures/data.json';

export default function* generator() {
    yield mockData;
}
